import { Component, OnInit, Input } from '@angular/core';
import { DeviceEnums } from '../../enums/device-enums';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/@core/services/auth.service';
import { UserService } from 'src/app/@core/services/user/user.service';
import { AppNotificationService } from '../../services/app-notifications.service';
import { OrganizationService } from 'src/app/@core/services/organization/organization.service';
import { User } from '../../modals/user.model';
import { Organization } from '../../modals/organization.model';
import {Location} from '@angular/common';
@Component({
  selector: 'app-organization-details',
  templateUrl: './organization-details.component.html',
  styleUrls: ['./organization-details.component.css']
})
export class OrganizationDetailsComponent implements OnInit {
  organizationId: number;
  organization: Organization;
  errorMessage: any;
  currentUser: User;
  isShowSelectBtn: boolean;

  constructor(private _organizationService: OrganizationService,
    private route: ActivatedRoute,
    private appNotificationService: AppNotificationService,
    private _userService: UserService,
    private _location: Location,
    private authService: AuthService,
    private router: Router) { }

  ngOnInit() { 
    // console.log(this.isShowSelectBtn);
    this.route.params
      .subscribe(
        (params: Params) => {
          this.organizationId = +params['id'];
          this.getOrganization();
        }
      );
    this.currentUser = this.authService.getCurrentUser();
    localStorage.getItem("from") && localStorage.getItem("from") === "auth" ? this.isShowSelectBtn = true : this.isShowSelectBtn = false
    }
  
  getOrganization() {
    this._organizationService.getOrganization(this.organizationId).subscribe(
      res => {
          let data: any = res;
          this.organization = data.data;
      },
      err => {
        // console.log(err.error.error);
        let error = err.error.error
        this.errorMessage = error.error
        this.appNotificationService.push(this.errorMessage, 'error');
      }
  )
  }
  selectOrganization() {
    this.currentUser.organization_id = this.organizationId;
    let device = {
      token: "fcm_token",
      uid:   "web-app" + new Date().toString()
    }
    let params = { 
      device: device,
      user: {
        organization_id: this.currentUser.organization_id
      }
    }
    this._userService.updateUserInfo(this.currentUser.id, params).subscribe(
      res => {
          let data: any = res;
          this.router.navigate(['/auth/set-min-donation']);
          // this.organization = data.data;
      },
      err => {
        // console.log(err.error.error);
        let error = err.error.error
        this.errorMessage = error.error
        this.appNotificationService.push(this.errorMessage, 'error');
      }
  )
  }
  RedirectToMinMax() {
    this.router.navigate(['/auth/set-min-donation']);
  }
  redirect(){
    this._location.back();
    // if (this.isShowSelectBtn === true) {
    //   this.router.navigate(['auth/select-organization']);

    // } else {
    //   this.router.navigate(['settings']);
    // }
  }

}
